<template>
  <page content-class="admin-campaign-list">
    <!-- Analytics Top Card -->
    <b-card no-body class="px-4 py-2 my-2 bg-light">
      <!-- <h3>Analytics</h3> -->
      <b-row class="pt-1">
        <b-col cols="12" sm="12">
          <div class="d-flex justify-content-between">
            <h3><strong>Analytics</strong></h3>
            <!-- Campaign Selector Dropdown -->
            <b-row>
              <b-col cols="6" sm="12">
                <b-form-select
                  size="sm"
                  class="mt-1"
                  v-model="selectedCampaignID"
                  :options="campaignOptions"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <!-- Campaign Analytics Card -->
    <b-card v-if="campaign" body-class="p-4" class="mt-3">
      <!-- Campaign Title and Color -->
      <div class="d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <b-img
            blank
            blank-color="#5F27CD"
            width="36"
            height="36"
            class="rounded"
          />
          <h3 class="ml-3">{{ campaign.title }}</h3>
        </div>
        <b-select
          style="max-width: 320px"
          size="sm"
          :options="[
            {'text': 'Display stats during campaign period', 'value': false },
            {'text': 'Display overall stats of jobs and content part of the campaign', 'value': true }
          ]"
          v-model="noTimePeriod"
        />
      </div>
      <!-- Overall Stats Section -->
      <div class="my-3 pt-2">
        <div class="d-flex justify-content-between">
          <h4><strong>Overall</strong></h4>
          <p class="text-primary link-styling text-decoration-underline">export</p>
        </div>
        <!-- Campaign Stats Card -->
        <b-card class="mb-sm-3">
          <b-row align-h="between">
            <!-- Job Stats Block -->
            <b-col cols="12" md="7">
              <stats-block v-bind="campaignStatsCard"/>
            </b-col>
            <!-- Applications Stats Block -->
            <b-col cols="12" md="5">
              <stats-block
                v-bind="applicationProcessStatsCard"
                :isRightAligned="true"
              />
            </b-col>
          </b-row>
        </b-card>
        <!-- Fun facts card -->
        <b-row v-if="campaign && campaign.stats && Array.isArray(campaign.stats.jobShares) && campaign.stats.jobShares.length">
          <b-col cols="12"><h3>User Facts</h3></b-col>
          <b-col
            md="6"
            class="py-2"
            v-for="key in Object.keys(campaign ? campaign.stats : {}).filter(el => getUserFunFacts(el))"
            :key="key"
          >
            <b-card class="h-100" :title="getUserFunFacts(key).title">
              <div v-html="getUserFunFacts(key).text"></div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="campaign && campaign.stats && Array.isArray(campaign.stats.jobShares) && campaign.stats.jobShares.length">
          <b-col cols="12" class="mt-3"><h3>Job Facts</h3></b-col>
          <b-col
            md="6"
            class="py-2"
            v-for="key in Object.keys(campaign ? campaign.stats : {}).filter(el => getJobFunFacts(el))"
            :key="key"
          >
            <b-card class="h-100" :title="getJobFunFacts(key).title">
              <div v-html="getJobFunFacts(key).text"></div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="campaign && campaign.stats && Array.isArray(campaign.stats.contentShares) && campaign.stats.contentShares.length">
          <b-col cols="12" class="mt-3"><h3>Content Facts</h3></b-col>
          <b-col
            md="6"
            class="py-2"
            v-for="key in Object.keys(campaign ? campaign.stats : {}).filter(el => getContentFunFacts(el))"
            :key="key"
          >
            <b-card class="h-100" :title="getContentFunFacts(key).title">
              <div v-html="getContentFunFacts(key).text"></div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- div>
        <!- Components Stats Section ->
        <div class="d-flex justify-content-between pt-2">
          <h4><strong>Details</strong></h4>
          <p class="text-primary link-styling text-decoration-underline">export</p>
        </div>
        <b-card class="mb-3">
          <component-stats
            :statsData="componentDataEmail"
          />
        </b-card>
        <b-card class="mb-3">
          <component-stats
            :statsData="componentDataReferral"
          />
        </b-card>
        <b-card class="mb-3">
          <component-stats
            :statsData="componentDataLeaderboard"
          />
        </b-card>
      </div -->
    </b-card>
  </page>
</template>

<script>
import gql from 'graphql-tag';
import Page from '@/components/campaign-admin/page';
import StatsBlock from '@/components/campaign-admin/StatsBlock.vue';
import ComponentStats from '@/components/campaign-admin/ComponentStats.vue';

const CampaignsListStatsQuery = gql`
  query CampaignsListStats {
    company {
      id
      campaigns {
        id
        title
      }
    }
  }
`;

const CampaignStatsQuery = gql`
  query CampaignsListStats(
    $campaignID: ID,
    $filters: CampaignStatsFilters
  ) {
    company {
      id
      campaign(where: { id: $campaignID }) {
        id
        title
        stats(filters: $filters) {
          jobShares {id userID jobID eventName fullName jobTitle timestamp }
          jobViews { id userID jobID eventName fullName jobTitle timestamp }
          contentShares { id userID contentShareID eventName fullName contentTitle timestamp }
          contentViews { id userID contentShareID eventName fullName contentTitle timestamp }
          applications { id userID applicationID jobID eventName fullName jobTitle candidateFullName timestamp }
          interviews { id userID applicationID jobID eventName fullName jobTitle candidateFullName timestamp }
          hires { id userID applicationID jobID eventName fullName jobTitle candidateFullName timestamp }
        }
      }
    }
  }
`;

// There are a few keys automatically added by apollo that has no
// additional meaning to the business logic
const excludedKeys = [
  '__typename'
];

export default {
  components: {
    Page,
    StatsBlock,
    ComponentStats
  },
  data: () => ({
    selectedCampaignID: null,
    noTimePeriod: true,
    componentDataEmail: {
      stats: [
        {
          key: 'users',
          label: 'Users',
          value: 32,
        },
        {
          key: 'opened',
          label: 'Opened',
          value: 12,
        },
        {
          key: 'clicked',
          label: 'Clicked',
          value: 10,
        },
      ],
      component: {
        title: 'Invitation Email',
        icon: 'envelope',
        iconColor: '#9c88ff',
        sendDate: new Date(2022, 5, 20),
      },
    },
    componentDataReferral: {
      stats: [
        {
          key: 'users',
          label: 'Users',
          value: 16,
        },
        {
          key: 'jobs',
          label: 'Jobs',
          value: 10,
        },
        {
          key: 'content',
          label: 'Content',
          value: 3,
        },
        {
          key: 'jobShares',
          label: 'Job Shares',
          value: 110,
        },
        {
          key: 'jobViews',
          label: 'Job Views',
          value: 212,
        },
        {
          key: 'contentShares',
          label: 'Content Shares',
          value: 96,
        },
        {
          key: 'contentViews',
          label: 'Content Views',
          value: 156,
        },
        {
          key: 'applications',
          label: 'Applications',
          value: 10,
        },
        {
          key: 'interviews',
          label: 'Interviews',
          value: 4,
        },
        {
          key: 'hires',
          label: 'Hires',
          value: 1,
        },
      ],
      component: {
        title: 'Our First Referral Jam',
        icon: 'trophy',
        iconColor: '#fbc531',
        startDate: new Date(2022, 5, 20, 12, 0),
        endDate: new Date(2022, 5, 20, 12, 30)
      },
    },
    componentDataLeaderboard: {
      stats: [
        {
          key: 'users',
          label: 'Users',
          value: 16,
        },
        {
          key: 'jobs',
          label: 'Jobs',
          value: 10,
        },
        {
          key: 'content',
          label: 'Content',
          value: 3,
        },
        {
          key: 'jobShares',
          label: 'Job Shares',
          value: 110,
        },
        {
          key: 'jobViews',
          label: 'Job Views',
          value: 212,
        },
        {
          key: 'contentShares',
          label: 'Content Shares',
          value: 96,
        },
        {
          key: 'contentViews',
          label: 'Content Views',
          value: 156,
        },
        {
          key: 'applications',
          label: 'Applications',
          value: 10,
        },
        {
          key: 'interviews',
          label: 'Interviews',
          value: 4,
        },
        {
          key: 'hires',
          label: 'Hires',
          value: 1,
        },
      ],
      component: {
        title: 'Our First Raffle Leaderboard',
        icon: 'gamepad',
        iconColor: '#e84118',
        startDate: new Date(2022, 5, 20, 12, 0),
        endDate: new Date(2022, 5, 20, 12, 30)
      },
    }
  }),
  apollo: {
    campaigns: {
      query: CampaignsListStatsQuery,
      update({ company }) {
        const { campaigns } = company;
        return campaigns;
      },
      result({ data }) {
        const { campaigns } = data.company || {};
        const [ campaign ] = Array.isArray(campaigns) ? campaigns : [];
        this.selectedCampaignID = (campaign || {}).id;
        return campaigns;
      },
      error(err) {
        this.$notifyFatalErr(err, { prepend: 'Failed to load the campaigns' });
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
    campaign: {
      query: CampaignStatsQuery,
      variables() {
        const { noTimePeriod, selectedCampaignID } = this;
        return { filters: { noTimePeriod }, campaignID: selectedCampaignID };
      },
      update({ company }) {
        const { campaign } = company;
        const { stats } = campaign || {};
        console.log({ stats });
        return campaign;
      },
      error(err) {
        this.$notifyFatalErr(err, { prepend: 'Failed to load the campaigns' });
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    campaignOptions() {
      const { campaigns } = this;
      return (campaigns || []).map(({ id, title }) => ({ value: id, text: title }));
    },
    campaignStatsCard() {
      const { stats } = this.campaign || {};
      return {
        labels: {
          JOB_SHARED: 'Job Shares',
          JOB_VIEWS: 'Job Views',
          CONTENT_SHARED: 'Content Shares',
          CONTENT_VIEWS: 'Content Views',
        },
        values: {
          JOB_SHARED: stats.jobShares.length,
          JOB_VIEWS: stats.jobViews.length,
          CONTENT_SHARED: stats.contentShares.length,
          CONTENT_VIEWS: stats.contentViews.length,
        },
        history: {
          JOB_SHARED: stats.jobShares,
          JOB_VIEWS: stats.jobViews,
          CONTENT_SHARED: stats.contentShares,
          CONTENT_VIEWS: stats.contentViews,
        }
      };
    },
    applicationProcessStatsCard() {
      const { stats } = this.campaign || {};
      return {
        labels: {
          APPLICATIONS_COUNT: 'Applications',
          INTERVIEWS_MADE: 'Interviews',
          FINAL_HIRES: 'Hires'
        },
        values: {
          APPLICATIONS_COUNT: stats.applications.length,
          INTERVIEWS_MADE: stats.interviews.length,
          FINAL_HIRES: stats.hires.length,
        },
        history: {
          APPLICATIONS_COUNT: stats.applications,
          INTERVIEWS_MADE: stats.interviews,
          FINAL_HIRES: stats.hires,
        }
      };
    },
    userTops() {
      const { campaign, mostFrequent } = this;
      const { stats } = campaign || {};
      if (!stats) return null;
      return Object.keys(stats).filter(el => !excludedKeys.includes(el)).reduce((res, key) => {
        const most = mostFrequent((stats[key]).map(({ userID }) => userID));
        const user = most.id ? stats[key].find(({ userID }) => userID === most.id) : null;
        res[key] = { fullName: (user || {}).fullName, count: most.count };
        return res;
      }, {});
    },
    jobTops() {
      const { campaign, mostFrequent } = this;
      const { stats } = campaign || {};
      if (!stats) return null;
      const extendedExcludedKeys = [ ...excludedKeys, 'contentShares', 'contentViews' ];
      return Object.keys(stats).filter(el => !extendedExcludedKeys.includes(el)).reduce((res, key) => {
        const most = mostFrequent(stats[key].map(({ jobID }) => jobID).filter(el => el));
        const job = most.id ? stats[key].find(({ jobID }) => jobID === most.id) : null;
        res[key] = { jobTitle: (job || {}).jobTitle, count: most.count };
        return res;
      }, {});
    },
    contentTops() {
      const { campaign, mostFrequent } = this;
      const { stats } = campaign || {};
      if (!stats) return null;
      const keys = [ 'contentShares', 'contentViews' ];
      return Object.keys(stats).filter(el => keys.includes(el)).reduce((res, key) => {
        const most = mostFrequent(stats[key].map(({ contentShareID }) => contentShareID).filter(el => el));
        const contentShare = most.id ? stats[key].find(({ contentShareID }) => contentShareID === most.id) : null;
        res[key] = { contentTitle: (contentShare || {}).contentTitle, count: most.count };
        return res;
      }, {});
    },
  },
  methods: {
    mostFrequent(array) {
      if (array.length === 0) return {};
      const modeMap = {};
      let maxEl = array[0];
      let maxCount = 1;
      for (let i = 0; i < array.length; i++) {
        const el = array[i];
        if (modeMap[el] == null)
          modeMap[el] = 1;
        else
          modeMap[el]++;
        if (modeMap[el] > maxCount) {
          maxEl = el;
          maxCount = modeMap[el];
        }
      }
      return { id: maxEl, count: maxCount };
    },
    getUserFunFacts(key) {
      const { fullName, count } = (this.userTops || {})[key] || {};
      const map = {
        jobShares: {
          title: 'Most Job Shares',
          text: `<b>${fullName}</b> has shared the most jobs with a total of sharing <b>${count}</b> times.`,
        },
        jobViews: {
          title: 'Most Job Views',
          text: `<b>${fullName}</b>'s shared jobs have been viewed the most, they were visited <b>${count}</b> times.`,
        },
        contentShares: {
          title: 'Most Content Shares',
          text: `<b>${fullName}</b> has shared the most content with a total of sharing <b>${count}</b> times.`,
        },
        contentViews: {
          title: 'Most Content Views',
          text: `<b>${fullName}</b> shared content has been viewed the most, it was visited <b>${count}</b> times.`,
        },
        applications: {
          title: 'Most Applications',
          text: `<b>${fullName}</b>'s connections have submitted the most applications, they have applied <b>${count}</b> times.`,
        },
        interviews: {
          title: 'Most Interviews',
          text: `<b>${fullName}</b>'s connections were interviewed the most, they have had <b>${count}</b> interviews alltogether.`,
        },
        hires: {
          title: 'Most Hires',
          text: `<b>${fullName}</b>'s connections got hired the most, <b>${count}</b> of them were hired so far.`,
        },
      };
      return fullName && count ? map[key] : null;
    },
    getContentFunFacts(key) {
      const { contentTitle: title, count } = (this.contentTops || {})[key] || {};
      const map = {
        contentShares: {
          title: 'Most Shares',
          text: `<b>${title}</b> has been shared the most with a total of <b>${count}</b> shares.`,
        },
        contentViews: {
          title: 'Most Views',
          text: `<b>${title}</b> has been viewed the most, with a total of <b>${count}</b> views.`,
        },
      };
      return title && count ? map[key] : null;
    },
    getJobFunFacts(key) {
      const { jobTitle: title, count } = (this.jobTops || {})[key] || {};
      const map = {
        jobShares: {
          title: 'Most Shares',
          text: `<b>${title}</b> has been shared the most with a total of <b>${count}</b> shares.`,
        },
        jobViews: {
          title: 'Most Views',
          text: `<b>${title}</b> has been viewed the most with a total of <b>${count}</b> views.`,
        },
        applications: {
          title: 'Most Applications',
          text: `<b>${title}</b> had the most applications with a total of <b>${count}</b> applications`,
        },
        interviews: {
          title: 'Most Interviews',
          text: `<b>${title}</b> had the most interviews with a total of <b>${count}</b> interviews`,
        },
        hires: {
          title: 'Most Hires',
          text: `<b>${title}</b> had the most hires with a total of <b>${count}</b> hires`,
        },
      };
      return title && count ? map[key] : null;
    },
  }
};
</script>

<style lang="scss">
    .referral-jam-event-settings {
        .event-logo {
            max-height: 30px;
            max-width: 200px;
        }
    }
    .link-styling {
      text-decoration: underline;
      cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/campaign-admin/CampaignAnalytics.vue